import React from 'react';
import { useApolloClient } from '@apollo/client';

import albumFragment, { AlbumFragment } from '../album.graphql';
import { FIRST } from '../detail/detail-loader';

type Edges = NonNullable<AlbumFragment['images']>['edges'];

const useWriteImagesCache = () => {
    const client = useApolloClient();

    const writeImagesCache = (id: string, edges: Edges) => {
        const album = client.readFragment<AlbumFragment>({
            id: `PostNode:${id}`,

            fragment: albumFragment,
            fragmentName: 'Album',
            variables: { first: FIRST },
        });

        if (album) {
            client.writeFragment<AlbumFragment>({
                id: `PostNode:${id}`,
                fragment: albumFragment,
                fragmentName: 'Album',
                variables: { first: FIRST },
                data: {
                    ...album,
                    images: album.images
                        ? {
                              ...album.images,
                              edges,
                          }
                        : null,
                },
            });
        }
    };

    return writeImagesCache;
};

export default useWriteImagesCache;
